<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Contract</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <contract-form :sizes="sizes" :data="data"></contract-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FormErrors from '../../../../components/FormErrors'
import { axios } from '../../../../utils'
import ContractForm from './ContractForm'
export default {
  name: 'ContractDialog',
  data() {
    return {
      data: {
        id: null,
        startDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
        saleDate: new Date().toISOString().substr(0, 10),
        categories: [],
        regions: '',
        suburbs: [],
        coverages: [],
        employee_id: null,
        size: '',
        notes: '',
        active: false,
        image: '',
        file: null
      },
      sizes: ['A', 'B', 'C', 'D'],

      loading: false,
      errors: []
    }
  },
  props: ['close', 'contracts', 'item', 'client_id'],
  components: {
    ContractForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      this.data.id = this.item.id
      // this.setContractId(this.item.id)
      console.log('getting contracts data for id ', this.item.id)
      axios
        .get('api/admin/contracts/' + this.item.id)
        .then(res => {
          console.log(res.data)
          this.data.active = res.data.active
          this.data.startDate = res.data.start_date
          this.data.endDate = res.data.end_date
          this.data.saleDate = res.data.sale_date
          this.data.categories = res.data.categories
          this.data.suburbs = res.data.suburbs
          this.data.regions = res.data.regions
          this.data.coverages = res.data.radius_coverages || []
          this.data.image = res.data.image
          this.data.size = res.data.size
          this.data.notes = res.data.notes
          this.data.employee_id = res.data.employee_id
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new contract')
      axios
        .post('api/admin/contracts/create', {
          ...this.data,
          client_id: this.client_id
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating contract data for id ', this.data)
      axios
        .put(`api/admin/contracts/${this.item.id}`, {
          ...this.data,
          client_id: this.client_id
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        id: null,
        image: '',
        startDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
        saleDate: new Date().toISOString().substr(0, 10),
        categories: [],
        regions: [],
        suburbs: [],
        coverages: [],
        employee: '',
        file: null,
        size: '',
        notes: '',
        active: false
      }
    }
  },
  watch: {
    'data.file': function(file) {
      this.fileLoading = true
      let formData = new FormData()
      let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
      if (file) {
        console.log('uploading file')
        if (file.size < 5000000) {
          formData.append('file', file)
          formData.append('model', 'contracts')
          formData.append('name', 'contract-image')
          if (this.data.id) {
            axios
              .post(
                `api/admin/contracts/${this.data.id}/upload-media`,
                formData,
                headers
              )
              .then(res => {
                this.data.image = res.data
                console.log(res.data)
                console.log('done')
                this.data.file = null
                this.fileLoading = false
              })
              .catch(err => console.log(err))
          } else {
            axios
              .post('api/admin/file-upload', formData, headers)
              .then(res => {
                this.data.image = res.data
                console.log(res.data)
                console.log('done')
                this.data.file = null
                this.fileLoading = false
              })
              .catch(err => console.log(err))
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
